import { cn, isNonEmpty } from '@ais-ui/utils';

interface EventGridItemProps {
  label: string | null | undefined;
  value: string | null | undefined;
  wrap?: boolean;
}

export const EventGridItem = ({ label, value, wrap }: EventGridItemProps) => {
  return (
    <div className="flex flex-col gap-1">
      <p className="text-sm font-medium flex-none">{label}</p>
      <p
        className={cn(
          'text-sm text-muted-foreground flex-grow break-words min-w-0',
          !wrap && 'truncate',
        )}
      >
        {isNonEmpty(value) ? value : 'Unknown'}
      </p>
    </div>
  );
};
